import React, { useEffect, useRef } from 'react';
import { createVeriffFrame, MESSAGES } from '@veriff/incontext-sdk';
import { useTvsState } from '../../utils/useTvsState';
import { trackPageView } from '../../tracking/tracking';
import { useClientConfig } from '../../utils/clientConfigContext';

interface VeriffFrame {
  close: () => void;
}

interface VeriffModalProps {
  sessionUrl: string;
}

const VeriffModalPage: React.FC<VeriffModalProps> = ({ sessionUrl }) => {
  const [, setTvsState] = useTvsState();
  const veriffFrameRef = useRef<VeriffFrame | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const { clientId } = useClientConfig();

  const cleanupVeriffFrame = () => {
    try {
      if (veriffFrameRef.current) {
        try {
          veriffFrameRef.current.close();
        } catch (error) {
          console.error('Error using close() method:', error);
        }
      }

      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }

      const veriffIframe = document.querySelector('iframe[src*="veriff"]');
      if (veriffIframe && veriffIframe.parentNode) {
        veriffIframe.parentNode.removeChild(veriffIframe);
      }

      veriffFrameRef.current = null;
    } catch (error) {
      console.error('Error during Veriff frame cleanup:', error);
    }
  };

  const handleCanceled = () => {
    setTvsState('verification_closed_veriff');
    requestAnimationFrame(() => {
      cleanupVeriffFrame();
    });
  };

  useEffect(() => {
    cleanupVeriffFrame();
    veriffFrameRef.current = createVeriffFrame({
      lang: 'de',
      url: sessionUrl,
      onEvent: (msg) => {
        if (msg === MESSAGES.STARTED) {
          trackPageView('is24.de.sicherheit.verifizierung.veriff.start', clientId);
        }
        if (msg === MESSAGES.CANCELED) {
          handleCanceled();
        } else if (msg === MESSAGES.FINISHED) {
          setTvsState('verification_check_veriff');
          cleanupVeriffFrame();
        }
      },
    });
    return () => {
      cleanupVeriffFrame();
    };
  }, [sessionUrl, setTvsState]);

  return <div id='veriff-frame' data-testid='veriff-frame' ref={containerRef} />;
};

export default VeriffModalPage;
